import React from "react";

import Window from "../threeDComponent/Window";

const MeshWindow = () => {
  return <Window />;
};

export default React.memo(MeshWindow);
